<div class="eosc-fb-dialog-plugin" hive-root>
    <h6 class="eosc-fb-dialog-plugin__title">
        Recommendation Details for
        <b>{{ renderInfo().targetName }}</b>
    </h6>
    <eosc-renewal-notice></eosc-renewal-notice>
    <footer class="eosc-fb-dialog-plugin__footer">
        <hive-button
            label="Dismiss Recommendation"
            emphasis="secondary"
            [disabled]="!renderInfo().allowDismiss() || renderInfo().actionInProgress()"
            hiveTooltip
            [hiveTooltipDescription]="renderInfo().allowDismiss() ? '' : 'Operation not permitted'"
            (click)="handleActionEvent(RecommendationActionEvent.DISMISS)"
        ></hive-button>
        <hive-button
            label="Cancel"
            emphasis="secondary"
            [disabled]="renderInfo().actionInProgress()"
            (click)="handleActionEvent(RecommendationActionEvent.CANCEL)"
        ></hive-button>
        <eosc-renew-button
            [eosc]="renderInfo().eosc"
            [actionInProgress]="renderInfo().actionInProgress()"
            (renew)="handleActionEvent(RecommendationActionEvent.RENEW_CONTRACT)"
        ></eosc-renew-button>
    </footer>
</div>
